import React, { useContext, useState } from "react";
import { useNavigation } from '@react-navigation/native'; // esto te sirve para navegar en el ambiente donde invocaste este componente
import {
  Alert,
  View,
  Image,
  StyleSheet,
  Platform,
  Dimensions,
  TouchableOpacity
} from "react-native";
//import { Image as ImageCache } from "react-native-expo-image-cache";
import { Video } from 'expo-av';

//import useAuth from "../auth/useAuth";
import routes from "../navigation/routes";
import dateNow from "../utility/dateNow";
import connectionConfig from "../config/settings";
import Text from "./Text";
import colors from "../config/colors";
import { AntDesign, MaterialCommunityIcons, Entypo, Fontisto, Foundation, Ionicons, FontAwesome5, Octicons } from "@expo/vector-icons";
import dateActions from "../utility/dateActions";
import textStyles from "../config/textStyles";
//import ImageHandlerFixo from "../utility/ImageHandlerFixo";
import ImageHandlerDichapp from "../utility/ImageHandlerDichapp";
import AuthContext from "../auth/context";



var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;
var textSmall = textStyles.textSmall


//const webUrl = connectionConfig.imageUrl + '/seedImages/'
var date = dateNow()
var numLikes = 0

function CardSeedOriginContent({
  title,
  imageUrl,
  onPress,
  onPressComment,
  thumbnailUrl,
  type,
  seedDate,
  userIdOfAction,
  userName,
  userPhoto,
  imageFitJPG,
  seedTotalSeedFollowersOrigin
}) {

//console.log("----999---- CardSeed: ", "seedId ", type, imageUrl)
  
  //var profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
  var webUrl = ''
  var profileUri = ''
  // var infoDocumetUri = connectionConfig.imageUrl + '/Documents/'
  // var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'

  if (connectionConfig.switchS3 === true) {
    webUrl = connectionConfig.imageUrlS3
    profileUri = connectionConfig.imageUrlS3
    //console.log('CardSeed -> guarda las imagenes en un bucket de aws S3  ')
  } else {
    console.log('CardSeed -> else switchS3')
    webUrl = connectionConfig.imageUrl + '/seedImages/'
    profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
  }

  const navigation = useNavigation(); // esto te sirve para navegar en el ambiente donde invocaste este componente
  const video = React.useRef(null);
  const [status, setStatus] = useState({});
  //const { user } = useAuth()

  const { user, setUser } = useContext(AuthContext);  
  
  var dateFormated = dateActions(seedDate)
  var userIdAuth = JSON.parse(user).userId;

  return (

    <View style={styles.card}>
      <View>
        <View style={styles.containerPhotoNameUser}>
          <View style={styles.viewImageUser} >
            {
              (Platform.OS === 'ios') ?
                imageUrl === 'http://18.116.234.21:5001/imagenes/PerfilDeUsuario' ?
                  <View style={styles.imageUser} >
                    <Foundation
                      name="mountains"
                      size={(windowWidth * .15)}         //100
                      color={colors.medium} />
                  </View>
                  :
                  <TouchableOpacity
                    onPress={() => {
                      {
                        if (userIdOfAction === userIdAuth) {
                          navigation.navigate(routes.USER_FIXO)
                        } else {
                          findUser()
                        }
                      }
                    }}
                  >
                    {
                          String(userPhoto).endsWith(".jpg") ?
                                      <Image style={styles.imageUser}
                                        //source={{ uri: perfilUri + route.params.item.userId + '_' + route.params.item.userPhoto + '_seedfit.jpg' }}
                                        source={{ uri: profileUri + JSON.parse(user).userId + "_" + JSON.parse(user).userPhoto.substring(0, 19) + '_userfit.jpg' }}
                                      />
                                      :
                                      <Image style={styles.imageUser}
                                        //source={{ uri: perfilUri + route.params.item.userId + '_' + route.params.item.userPhoto + '_seedfit.png' }}
                                        source={{ uri: profileUri + JSON.parse(user).userId + "_" + JSON.parse(user).userPhoto.substring(0, 19) + '_userfit.png' }}
                                      />
                                  }
                    {/* <ImageCache
                      style={styles.imageUser}
                      tint="light"
                      preview={{ uri: thumbnailUrl }}
                      uri="https://placekitten.com/200/300"
                      //uri={profileUri + userIdOfAction + '_' + userPhoto}
                      //onError={(error) => console.log('Error loading image:', error)}
                    /> */}
                  </TouchableOpacity>
                :
                null
            }
            {
              (Platform.OS === 'android') ?
                imageUrl === 'http://18.116.234.21:5001/imagenes/PerfilDeUsuario' ?
                  <View style={styles.imageUser} >
                    <Foundation
                      name="mountains"
                      size={(windowWidth * .10)}   //100 
                      color={colors.medium} />
                  </View>
                  :
                  <TouchableOpacity
                    onPress={() => {
                      {
                        if (userIdOfAction === userIdAuth) {
                          navigation.navigate(routes.USER_FIXO)
                        } else {
                          findUser()
                        }
                      }
                    }}
                  >
                    <Image
                      style={styles.imageUser}
                      tint="light"
                      preview={{ uri: thumbnailUrl }}
                      source={{ uri: profileUri + userIdOfAction + '_' + userPhoto }}
                    />
                  </TouchableOpacity>
                :
                null
            }
          </View>
          <Text style={styles.userName}> {userName}  </Text>

        </View>

        <View style={styles.containerIcon}>
          {
             type === 0 ?
              <View style={styles.viewIconAndNameAction}>
                <Text style={styles.actionName}> Semilla </Text>
                <View style={styles.iconOfAction0}>
                  {
                    <FontAwesome5
                     name={"seedling"}
                    color={"#8DF78D"}
                      size={19}
                      onPress={onPress}
                    />
                  }
                </View>
              </View>
              :
            type === 1 ?
              <View style={styles.viewIconAndNameAction}>
                <Text style={styles.actionName}> Información </Text>
                <View style={styles.iconOfAction1}>
                  {
                    <AntDesign
                      name={"infocirlceo"}
                      color={colors.chakra1nar}
                      size={19}
                      onPress={onPress}
                    />
                  }
                </View>
              </View>
              :
              type === 2 ?
                <View style={styles.viewIconAndNameAction}>
                  <Text style={styles.actionName}> Idea </Text>
                  <View style={styles.iconOfAction2}>
                    {
                      <MaterialCommunityIcons
                        name={"lightbulb-on-outline"}
                        color={colors.chakra2ama}
                        size={20}
                        onPress={onPress}
                      />
                    }
                  </View>
                </View>
                :
                type === 3 ?
                  <View style={styles.viewIconAndNameAction}>
                    <Text style={styles.actionName}> Plan </Text>
                    <View style={styles.iconOfAction3}>
                      {
                        <Fontisto
                          name={"map"}
                          color={colors.green}
                          size={16}
                          onPress={onPress}
                        />
                      }
                    </View>
                  </View>
                  :
                  type === 4 ?
                    <View style={styles.viewIconAndNameAction}>
                      <Text style={styles.actionName}> Acción </Text>
                      <View style={styles.iconOfAction4}>
                        {
                          <FontAwesome5
                            name={"people-carry"}   //tractor people-carry
                            color={"blue"}
                            size={15}
                            onPress={onPress}
                          />
                        }
                      </View>
                    </View>
                    :
                    type === 5 ?
                      <View style={styles.viewIconAndNameAction}>
                        <Text style={styles.actionName}> Atraer personas </Text>
                        <View style={styles.iconOfAction5}>
                          {
                            <Octicons
                              name={"megaphone"}
                              color={colors.chakra5vlt}
                              size={20}
                              onPress={onPress}
                            />
                          }
                        </View>
                      </View>
                      :
                      type === 6 ?
                        <View style={styles.viewIconAndNameAction}>
                          <Text style={styles.actionName}> Hacer divertida la semilla </Text>
                          <View style={styles.iconOfAction6}>
                            {
                              <FontAwesome5
                                name={"hat-wizard"}
                                color={colors.mexicanPink}
                                size={18}
                                onPress={onPress}
                              />
                            }
                          </View>
                        </View>
                        :
                        type === 7 ?
                          <View style={styles.viewIconAndNameAction}>
                            <Text style={styles.actionName}> Ramifica esta semilla </Text>
                            <View style={styles.iconOfAction7}>
                              {
                                <Fontisto
                                  name={"sourcetree"}
                                  color={colors.chakra7ryo}
                                  size={19}
                                  onPress={onPress}
                                />
                              }
                            </View>
                          </View>
                          :
                          type === 39 ?
                          <View style={styles.viewIconAndNameAction}>
                            <Text style={styles.actionName}> Requerimiento </Text>
                        
                          </View>
                          :
                          type === 40 ?
                          <View style={styles.viewIconAndNameAction}>
                            <Text style={styles.actionName}> Subrequerimiento </Text>                        
                          </View>
                          :
                          type === 41 ?
                          <View style={styles.viewIconAndNameAction}>
                            <Text style={styles.actionName}> Support </Text>                       
                          </View>
                          :
                          null
          }
        </View>

        {/* <TouchableOpacity onPress={onPress}> */}
        <View style={styles.primerRow}>

          <View style={styles.titleDescription}>
            <Text style={styles.titleAc} >
              Acción origen
            </Text>
            <Text style={styles.title} >
              {title}
            </Text>
            {/* <Text style={styles.date} >
              {dateFormated}
            </Text> */}

            <View style={styles.likeAndCommentContainer}>
            <Text style={styles.date} >
              {dateFormated}
            </Text>
              {/* <Text style={styles.tree} numberOfLines={1} >
                <Entypo name={"tree"}
                  color={colors.commentsIcon}
                  size={colors.miniSizeTree}
                  onPress={onPress}
                />
              </Text>
              <Text style={styles.totalActions} // Número de acciones(ramas)Tree
                numberOfLines={1} >
                {totalActions}
              </Text> */}
              <Text style={styles.comments} numberOfLines={1} >
                <Ionicons name={"people"}
                  color={colors.commentsIcon}
                  size={colors.sizeTree}
                  onPress={onPressComment}
                />
              </Text>
              <Text style={styles.totalActions} // Número de acciones(ramas)Tree
                numberOfLines={1} >
                {seedTotalSeedFollowersOrigin}
              </Text>
              {/* <Text style={styles.comments} numberOfLines={1} >
                <MaterialCommunityIcons name={"brain"}
                  color={colors.commentsIcon}
                  size={colors.sizeTree}
                //onPress={onPressComment} 
                />
              </Text>
              <Text style={styles.totalActions} // Número de acciones(ramas)Tree
                numberOfLines={1} >
                {subTitle}
              </Text> */}
            </View>


          </View>


      <TouchableOpacity style={styles.viewImages}
          onPress={onPress}>
        <ImageHandlerDichapp
          imageUrl={imageUrl}
          imageType="seedConcat"
          //thumbnailUrl={thumbnailUrl}
          styleImage={
            type === 0 ? styles.image :
            type === 1 ? styles.image1 :
            type === 2 ? styles.image2 :
            type === 3 ? styles.image3 :
            type === 4 ? styles.image4 :
            type === 5 ? styles.image5 :
            type === 6 ? styles.image6 :
            type === 7 ? styles.image7 :
            type === 8 ? styles.image8 :
            styles.image9
          }
          resizeMode="contain"
          //onPress={onPress}
         // navigation={navigation}
          //routes={routes}
        />
        </TouchableOpacity>

          {/* {(Platform.OS === 'ios') ?
            imageUrl.includes('.mp4') ?
              <Video
                ref={video}
                style={type === 0 ? styles.image :
                  type === 1 ? styles.image1 :
                    type === 2 ? styles.image2 :
                      type === 3 ? styles.image3 :
                        type === 4 ? styles.image4 :
                          type === 5 ? styles.image5 :
                            type === 6 ? styles.image6 :
                              type === 7 ? styles.image7 :
                                type === 8 ? styles.image8 :
                                  styles.image9
                }
                source={{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode="stretch"  // Con esto la imagen se adecuará a un view más pequeño!! 
                isLooping
                onPlaybackStatusUpdate={status => setStatus(() => status)}
              />
              :
              imageUrl.includes('.mov') ?
                <Video
                  ref={video}
                  style={type === 0 ? styles.image :
                    type === 1 ? styles.image1 :
                      type === 2 ? styles.image2 :
                        type === 3 ? styles.image3 :
                          type === 4 ? styles.image4 :
                            type === 5 ? styles.image5 :
                              type === 6 ? styles.image6 :
                                type === 7 ? styles.image7 :
                                  type === 8 ? styles.image8 :
                                    styles.image9
                  }
                  source={{
                    uri: imageUrl
                  }}
                  useNativeControls
                  resizeMode="stretch"
                  isLooping
                  onPlaybackStatusUpdate={status => setStatus(() => status)}
                />
                :
                imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
                  <View style={styles.imageMountain} >
                    <Foundation //style={styles.imageMountain}
                      name="mountains"
                      size={70}
                      color={colors.medium}
                      onPress={onPress} />
                  </View>
                  :
                  String(imageUrl).includes('Poner Foto') ?
                    <View style={styles.imageMountain} >
                      <Foundation //style={styles.imageMountain}
                        name="mountains"
                        size={70}
                        color={colors.medium}
                        onPress={onPress} />
                    </View>
                    :
                    <TouchableOpacity style={styles.viewImages}
                      onPress={onPress}
                    >
                      <ImageCache
                        resizeMode="contain"
                        style={type === 0 ? styles.image :
                          type === 1 ? styles.image1 :
                            type === 2 ? styles.image2 :
                              type === 3 ? styles.image3 :
                                type === 4 ? styles.image4 :
                                  type === 5 ? styles.image5 :
                                    type === 6 ? styles.image6 :
                                      type === 7 ? styles.image7 :
                                        type === 8 ? styles.image8 :
                                          styles.image9
                        }
                        tint="light"
                        preview={{ uri: thumbnailUrl }}
                        //uri={imageUrl}
                        source={{ uri: imageUrl }}
                      />
                    </TouchableOpacity>
            :
            null
          } */}
          {/* {(Platform.OS === 'android') ?
            imageUrl.includes('.mp4') ?
              <Video
                ref={video}
                style={type === 0 ? styles.image :
                  type === 1 ? styles.image1 :
                    type === 2 ? styles.image2 :
                      type === 3 ? styles.image3 :
                        type === 4 ? styles.image4 :
                          type === 5 ? styles.image5 :
                            type === 6 ? styles.image6 :
                              type === 7 ? styles.image7 :
                                type === 8 ? styles.image8 :
                                  styles.image9
                }
                source={{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode="stretch"  // Con esto la imagen se adecuará a un view más pequeño!! 

                isLooping
                onPlaybackStatusUpdate={status => setStatus(() => status)}
              />
              :
              imageUrl.includes('.mov') ?
                <Video
                  ref={video}
                  style={type === 0 ? styles.image :
                    type === 1 ? styles.image1 :
                      type === 2 ? styles.image2 :
                        type === 3 ? styles.image3 :
                          type === 4 ? styles.image4 :
                            type === 5 ? styles.image5 :
                              type === 6 ? styles.image6 :
                                type === 7 ? styles.image7 :
                                  type === 8 ? styles.image8 :
                                    styles.image9
                  }
                  source={{
                    uri: imageUrl
                  }}
                  useNativeControls
                  resizeMode="stretch"
                  isLooping
                  onPlaybackStatusUpdate={status => setStatus(() => status)}
                />
                :
                imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
                  <View style={styles.imageMountain} >
                    <Foundation //style={styles.imageMountain}
                      name="mountains"
                      size={70}
                      color={colors.medium}
                      onPress={onPress} />
                  </View>
                  :
                  String(imageUrl).includes('Poner Foto') ?
                    <View style={styles.imageMountain} >
                      <Foundation //style={styles.imageMountain}
                        name="mountains"
                        size={70}
                        color={colors.medium}
                        onPress={onPress} />
                    </View>
                    :
                    <TouchableOpacity style={styles.viewImages}
                      onPress={onPress}>
                      <Image
                        resizeMode="contain"
                        style={type === 0 ? styles.image :
                          type === 1 ? styles.image1 :
                            type === 2 ? styles.image2 :
                              type === 3 ? styles.image3 :
                                type === 4 ? styles.image4 :
                                  type === 5 ? styles.image5 :
                                    type === 6 ? styles.image6 :
                                      type === 7 ? styles.image7 :
                                        type === 8 ? styles.image8 :
                                          styles.image9
                        }
                        tint="light"
                        preview={{ uri: thumbnailUrl }}
                        //uri={imageUrl}
                        source={{ uri: imageUrl }}
                      />
                    </TouchableOpacity>
            :
            null
          } */}

        </View>
      </View>
    </View>

  );
}

const styles = StyleSheet.create({
  retribuitionTextOff: {
          color: colors.white,
          fontSize: textSmall,
          textAlign: 'center',
        //  marginLeft:(windowWidth * .02),
      },
  retribuitionTextOn: {
          color:  '#A88F1A', //'#AD9525', //'#998730',//colors.aguacateGreen,
          fontSize: textSmall,
          textAlign: 'center',
      },
  buttonRetribuitonOff:{
          backgroundColor: colors.primary,
          marginLeft: -6,
          width: (windowWidth * .2),  //70,
          borderRadius: (windowWidth * .06), //35,
          textAlign: "center",
      },
  buttonRetribuitonOn:{
          backgroundColor: colors.fuente,
          marginLeft: -6,
          width: (windowWidth * .2),  //70,
          height: (windowHeight * .026),
          borderRadius: (windowWidth * .06), //35,
          textAlign: "center",
      },
  dateComment: {
          color: colors.medium,
          fontSize: (windowWidth * .03),
          marginRight: (windowWidth * .09),
          marginTop: "3%" 
      },
  containerPhotoNameUser: {
    flexDirection: "row",
    width: (windowWidth * .5),
    //backgroundColor: "white",
    marginBottom: (windowWidth * -.085)
  },
  containerIcon: {
    alignSelf: "flex-end",
    marginRight: (windowWidth * .015),
    marginTop: (windowWidth * .01),
    //backgroundColor: "red", 
    width: (windowWidth * .5)  //"50%"
  },
  viewIconAndNameAction: {
    flexDirection: "row",
    alignSelf: "flex-end",
    //backgroundColor: "blue", 
    alignItems: "center",
  },
    iconOfAction0: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "#8DF78D",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 1,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: "#EBAB91"
  },

  iconOfAction1: {
    flexDirection: "row",
    height: (windowWidth * .075),
    width: (windowWidth * .075),
    borderRadius: 25,
    borderWidth: 2,
    borderColor: colors.chakra1nar,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction2: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 2,
    borderColor: colors.chakra2ama,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction3: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 2,
    borderColor: colors.green,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction4: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 2,
    borderColor: "blue",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction5: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra5vlt,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction6: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 2,
    borderColor: colors.mexicanPink,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction7: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 2,
    borderColor: colors.chakra7ryo,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  actionName: {
    fontSize: colors.textSmall,
    color: colors.textGeneral,
    marginTop: "4%",
    //textAlignVertical: "bottom",
    marginRight: "1.5%",
  },
  userName: {
    fontSize: colors.textSmall,
    color: colors.textGeneral,
    marginTop: "4%",
    marginLeft: "-8%"
  },
  imageUser: {
    width: (windowWidth * .07),           //74,
    height: (windowWidth * .07),          //74,
    borderRadius: 36,
    marginTop: "7%",
    marginLeft: "12%",
  },
  card: {
    //borderRadius: 15,
    marginTop: 1,
    //backgroundColor: colors.fondoImagenes,        //colors.verdeCaribe,
    overflow: "hidden",
  },
  fondo1: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra1nar
  },
  fondo2: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra2ama
  },
  fondo3: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra3ver
  },
  fondo4: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra4azu
  },
  fondo5: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra5vlt
  },
  fondo6: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra6rsa
  },
  fondo7: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra7ryo
  },
  fondo9: {
    marginLeft: "1%",
    marginRight: "1%",
    borderRadius: 15,
    backgroundColor: colors.light,
    marginBottom: 15,
    overflow: "hidden",
    borderWidth: 4,
    borderColor: colors.chakra9aur
  },
  primerRow: {
    flexDirection: "row",
  },
  titleDescription: {
    width: (windowWidth * 0.79), //"50%",
  },
  detailsContainer: {
    padding: 20,
  },
  imageMountain: {
    alignItems: "center",
    marginTop: "1.5%",
    marginLeft: "-1.5%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.medium,
    backgroundColor: colors.fondoImagenes,
  },
  likeAndCommentContainer: {
    //marginTop: 20,
    flexDirection: "row",
    width: "100%",
    height: (windowWidth * .07),  //35,
    alignItems: "baseline",
  },
  likeAndCommentNumbersContainer: {
    flexDirection: "row",
    width: "100%",
    height: 40,
    marginTop: "-1%",
  },
  likes: {
    marginLeft: "20%",
  },
  totalActions: {
    marginLeft: "3%",
    marginTop: "0.7%",
    color: colors.commentsIcon,
    fontSize: colors.textMedium,
    fontWeight: colors.fontWeightMedium
  },
  commentsNum: {
    marginLeft: "40%",
    color: colors.textGeneral,
    fontSize: colors.textSmall,
  },
  comments: {
    //marginLeft: "10%",
    color: colors.medium,

  },
  tree: {
    marginLeft: "10%",
    color: colors.medium,
  },
  subTitle: {
    color: colors.textGeneral,
    fontSize: colors.textSmall,
    marginLeft: "4%"
  },
    titleAc: {
    marginTop: "-6%",
    width: (windowWidth * .66),  //"59%",
    marginLeft: "2%",
    marginRight: "3%",
    marginBottom: 3,
    fontSize: colors.textMedium,   //18,
    fontWeight: colors.fontWeightLarge,  
    textAlign: "justify",
    color: colors.textGeneral
  },
  title: {
    marginTop: "1%",
    width: (windowWidth * .66),  //"59%",
    marginLeft: "2%",
    marginRight: "3%",
    marginBottom: 3,
    fontSize: colors.textMedium,   //18,
    fontWeight: "900",//colors.fontWeightLarge,  ,
    textAlign: "justify",
    color: colors.textGeneral
  },
  date: {
    marginTop: "1%",
    width: (windowWidth * .66),  //"59%",
    marginLeft: "2%",
    marginRight: "-20%",
    marginBottom: 3,
    fontSize: 12,   //18,
    color: colors.textGeneral
  },
  description: {
    width: "59%",
    marginLeft: "2%",
    marginRight: "3%",
    marginBottom: 7,
    fontSize: 18,
    textAlign: "justify"
  },
  viewImages: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1.5%",
    marginLeft: "-12%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
  },
  image: {
    marginTop: "1.5%",
    marginLeft: "-16%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.seedGreen,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image1: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.chakra1nar,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image2: {
    marginTop: "1.5%",
    marginLeft: "1%",
    marginBottom: "1%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.chakra2ama,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image3: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.chakra3ver,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image4: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.chakra4azu,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image5: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.chakra5vlt,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image6: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.chakra6rsa,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image7: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.chakra7ryo,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
  image9: {
    marginTop: "1.5%",
    marginLeft: "1%",
    borderRadius: 15,
    width: (windowWidth * 0.18),    //150,
    height: (windowWidth * 0.18),   //150,
    borderWidth: 3,
    borderColor: colors.chakra9aur,
    backgroundColor: colors.fondoImagenes,
    alignItems: "center",
  },
});

export default CardSeedOriginContent;
